import categoriesSlice from './categoriesSlice';

export * from './thunks';

export default categoriesSlice;
